import React from 'react';
import "./index.css";
import api from "../../../../../../util/clipstore/broadcaster/library";

PricingSmall.propTypes = {};

const perVideo = (pricing) => {
    if (pricing.type === "free") {
        return "FREE";
    } else {
        return api.formatPrice(pricing.price, "video");
    }
}

const perMin = (pricing) => {
    return api.formatPrice(pricing.ppm, "min");
}

function PricingSmall(props) {
    return (
        <div className="display-flex-justify-content-flex-start-align-items-center">
            <div className="pricing-small-bg pricing-small-text">
                {perVideo(props.pricing)}
            </div>
            {
                props.pricing.ppm !== 0 &&
                <div className="pricing-small-bg pricing-small-text">
                    {perMin(props.pricing)}
                </div>
            }
        </div>
    );
}

export default PricingSmall;